import List from 'components/Common/List'
import Accordion from 'LuxKit/Accordion'
import HTMLRender from 'LuxKit/HTMLRender'
import BodyText from 'LuxKit/Typography/BodyText'
import { useIntl } from 'react-intl'
import LargeContentToggle from 'components/Common/LargeContentToggle'

interface Props {
  offer: App.MerchandiseOffer
}

function MerchandiseOfferPageOverviewSection(props: Props) {
  const { offer } = props
  const intl = useIntl()

  return <div>
    {offer.copy.description && <Accordion
      heading={intl.formatMessage({
        id: 'w-UYq_tHTcSC2ijYZLXp',
        defaultMessage: 'Overview',
        description: 'Accordion heading for product overview section in the merchandise shop section',
      })}
      defaultOpen
    >
      <LargeContentToggle
        maxHeight={208}
        showMoreText={intl.formatMessage({
          id: 'jvRqMa64z5N1GL8KfM2w',
          defaultMessage: 'Read more',
          description: 'Action button label to read more and expand a truncated content section',
        })}
        showLessText={intl.formatMessage({
          id: 'zZTgX8l4ycvOEHHhSfUX',
          defaultMessage: 'Read less',
          description: 'Action button label to collapse content in the merchandise shop section',
        })}
      >
        <HTMLRender content={offer.copy.description} />
      </LargeContentToggle>
    </Accordion>}
    {!!offer.copy.features.length && <Accordion heading={intl.formatMessage({
      id: 'GDpA_Y-U8YqTPYjKi5AH',
      defaultMessage: 'Features',
      description: 'Accordion heading for product features section in the merchandise shop section',
    })}
    >
      <List spaced>
        {offer.copy.features.map(feature => <BodyText
          variant="medium"
          as="li"
          colour="light-foreground-alt"
          key={feature}
        >
          {feature}
        </BodyText>)}
      </List>
    </Accordion>}
    {offer.copy.specifications && <Accordion heading={intl.formatMessage({
      id: 'E5SrLCGZCv1e8E1dNRfD',
      defaultMessage: 'Specifications',
      description: 'Accordion heading for product specifications section',
    })}
    >
      <HTMLRender content={offer.copy.specifications} />
    </Accordion>}
    {offer.copy.shippingPolicy && <Accordion heading={intl.formatMessage({
      id: 'ynz6i5YU5-eUmNkYu7ln',
      defaultMessage: 'Shipping information',
      description: 'Accordion heading for shipping policy section in the merchandise shop section',
    })}
    >
      <HTMLRender content={offer.copy.shippingPolicy} />
    </Accordion>}
    {offer.copy.returnPolicy && <Accordion heading={intl.formatMessage({
      id: 'Wza5mNJuUqFIM-TyKddC',
      defaultMessage: 'Returns information',
      description: 'Accordion heading for returns policy section in the merchandise shop section',
    })}
    >
      <HTMLRender content={offer.copy.returnPolicy} />
    </Accordion>}
  </div>
}

export default MerchandiseOfferPageOverviewSection
